<template>
  <div
    v-bind:class="{ 'to-right': !show, 'to-left': show }"
    class="main d-none d-sm-none d-md-block"
  >
    <div class="hide">
      <div @click="showChanged">
        <v-icon>
          {{ show ? "fas fa-arrow-alt-to-right" : "fas fa-arrow-alt-to-left" }}
        </v-icon>
      </div>
    </div>

    <div class="header-details">
      <h2 class="title">Detalles de la ruta</h2>
      <span v-if="business">{{ business.shortName }}</span>
    </div>

    <div class="no-item" v-if="!allPoints.length">
      <i class="fas fa-hand-point-up mr-5"></i>
      Clic en el mapa para iniciar.
    </div>

    <div class="points">
      <points
        ref="points-c"
        @edit="edit"
        @delete="deletePoint"
        @changed="positionsUpdated"
        :points="allPoints"
        :business="business || {}"
      />
    </div>

    <div v-bind:class="{ details: true, sha: waypoints.length > 1 }">
      <v-text-field
        rounded
        v-if="waypoints.length > 1"
        filled
        placeholder="Hora de incio"
        label="Hora de incio"
        class="mt-2 mr-3 mb-2"
        v-model="deliveryTime"
        @click="showTimePicker"
        hide-details
      />

      <p v-if="waypoints.length > 1">
        <b>Distancia</b> : {{ (routeData.routeDistance / 1000).toFixed(2) }} KM
      </p>
      <p v-if="waypoints.length > 1">
        <b>Total a pagar</b> :
        {{ routeData.routeCost | currency }}
      </p>

      <!-- <div style="position: absolute; bottom: 0; width: 100%"> -->
      <v-btn
        height="55"
        rounded
        v-if="waypoints.length > 1"
        :disabled="waypoints.length < 2"
        color="primary"
        width="90%"
        @click="create"
        class="button ma-3"
      >
        <v-icon class="mr-5">far fa-hand-holding-box</v-icon>
        Crear mandado
      </v-btn>
      <!-- </div> -->
    </div>

    <v-dialog
      width="500"
      persistent
      v-model="timePickerDialog"
      v-if="timePickerDialog"
    >
      <time-picker
        @success="timeSelected"
        :timeData="timeData"
        @cancel="timePickerDialog = false"
      ></time-picker>
    </v-dialog>
  </div>
</template>

<script>
import points from "@/components/points";
import timePicker from "@/components/timePicker";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");

export default {
  name: "errand-details",
  props: ["waypoints", "business", "routeData"],

  data() {
    return {
      show: true,
      timePickerDialog: false,
      timeData: {
        soon: true,
      },
    };
  },

  components: {
    points,
    timePicker,
  },
  computed: {
    allPoints() {
      let points = [];

      for (let i = 0; i < this.waypoints.length; i++) {
        if (this.routeData[`point_${i + 1}`]) {
          points.push(this.routeData[`point_${i + 1}`]);
        }
      }

      return points;
    },
    deliveryTime() {
      if (this.timeData.soon) {
        return "Lo antes posible";
      } else {
        return moment(
          `${this.timeData.date} ${this.timeData.time}`,
          "YYYY-MM-DD hh:mm"
        ).format("DD-MMM-YY hh:mm A");
      }
    },
  },
  filters: {
    currency: function (amount) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "HNL",
        minimumFractionDigits: 2,
      });
      return formatter.format(amount);
    },
  },

  methods: {
    edit(e) {
      this.$emit("edit", e);
    },

    timeSelected(e) {
      this.timePickerDialog = false;
      this.timeData = e;
    },

    showTimePicker() {
      this.timePickerDialog = true;
    },

    showChanged() {
      this.show = !this.show;
      this.$emit("show", this.show);
    },
    deletePoint(e) {
      this.$emit("delete", e);
    },
    async positionsUpdated(e) {
      this.$emit("positionUpdated", e);
    },

    create() {
      this.$emit("create");
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  position: absolute;
  top: 0;
  right: 0;
  height: 100vh;
  max-height: 100vh;
  width: 400px;
  z-index: 8;
  background-color: #fff;

  // border-left: 1px solid rgb(92, 92, 92);

  filter: drop-shadow(0px 0px 20px rgba(#525252, 0.6));

  &::after {
    content: "";
    position: absolute;
    width: 400px;
    height: 100vh;
    right: -50%;
    top: 0;
    background: white;
    z-index: -1;
  }

  .header-details {
    display: grid;
    justify-content: center;
    align-items: center;
    height: 10vh;
    max-height: 10vh;
    padding: 10px;

    h2 {
      font-weight: 900;
      font-size: 30px !important;
      color: #00cdbc;
    }

    span {
      color: #000000;
      text-align: end;
      font-weight: bold;
    }
  }

  .points {
    display: grid;
    height: 60vh;
    max-height: 60vh;
    padding: 10px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-top: 50px;
  }

  .details {
    height: 30vh;
    max-height: 30vh;
    padding: 10px;
    overflow: auto;

    display: flex;
    flex-direction: column;

    p {
      margin: 0;
      padding: 8px;
      color: black;
    }
  }

  .sha {
    -webkit-box-shadow: 0px -4px 10px #d4d4d4;
    -moz-box-shadow: 0px -4px 10px #d4d4d4;
    box-shadow: 0px -4px 10px #d4d4d4;
  }

  .no-item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 68vh;
    color: #818181a7;
    font-size: 20px;
    font-weight: bold;
  }
}

.hide {
  width: 30px;
  position: absolute;
  transform: translateX(-30px);
  height: calc(100vh - 50%);
  margin-top: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    cursor: pointer;
    background-color: rgb(255, 255, 255);
    height: 8vh;

    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    border-right: 0 !important;
    border-radius: 15px 0 0 15px;

    i {
      color: #8e8e8e;
    }
  }

  .active {
    background-color: rgb(255, 255, 255);

    i {
      color: #8e8e8e;
    }
  }
}

.to-right {
  right: -390px;
  animation: run 0.2s ease-out;
}

@keyframes run {
  0% {
    right: 0;
  }

  100% {
    right: -390px;
  }
}

.to-left {
  right: 0;
  animation: run-left 0.2s ease-in;
}

@keyframes run-left {
  0% {
    right: -390px;
  }

  100% {
    right: 0;
  }
}

// @media screen and (max-width: 992px) {
//   @media (orientation: landscape) {
//     .main {
//       width: 200px;

//       &::after {
//         content: "";
//         position: absolute;
//         width: 200px;
//         height: 100vh;
//         right: -50%;
//         top: 0;
//         background: white;
//         z-index: -1;
//       }

//       .header-details {
//         display: grid;
//         justify-content: center;
//         align-items: center;
//         height: 10vh;
//         max-height: 10vh;
//         padding: 10px;

//         h2 {
//           font-weight: 900;
//           font-size: 30px !important;
//           color: #00cdbc;
//         }

//         span {
//           color: #000000;
//           text-align: end;
//           font-weight: bold;
//         }
//       }

//       .points {
//         display: grid;
//         height: 62vh;
//         max-height: 62vh;
//         padding: 10px;
//         overflow-y: auto;
//         overflow-x: hidden;
//         padding-top: 50px;
//       }

//       .details {
//         height: 28vh;
//         max-height: 28vh;
//         padding: 10px;
//         overflow: auto;

//         p {
//           margin: 0;
//           padding: 8px;
//           color: black;
//         }
//       }

//       .sha {
//         -webkit-box-shadow: 0px -4px 10px #d4d4d4;
//         -moz-box-shadow: 0px -4px 10px #d4d4d4;
//         box-shadow: 0px -4px 10px #d4d4d4;
//       }

//       .no-item {
//         display: flex;
//         justify-content: center;
//         align-items: center;
//         height: 68vh;
//         color: #818181a7;
//         font-size: 20px;
//         font-weight: bold;
//       }
//     }
//   }
// }
</style>